function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import Modal from "react-modal";
import Icon from "monday-ui-react-core/dist/Icon";
import Close from "monday-ui-react-core/dist/icons/Close";
import ModalContentComponent from "./modal-content/modal-content-component";
import { StyledCloseButton } from "./modal-with-signup-component.scss";
import DefaultProps from "./default-props";
const ModalWithSignupComponent = (props)=>{
    const { onCloseModal } = props;
    useEffect(()=>{
        Modal.setAppElement("body");
    }, []);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx(StyledCloseButton, {
                className: "close-button",
                onClick: onCloseModal,
                children: /*#__PURE__*/ _jsx(Icon, {
                    iconType: Icon.type.SVG,
                    icon: Close,
                    iconSize: 24
                })
            }),
            /*#__PURE__*/ _jsx(ModalContentComponent, _object_spread({}, props))
        ]
    }));
};
ModalWithSignupComponent.defaultProps = DefaultProps;
export default ModalWithSignupComponent;
